const mapOptionsByImageIndex = (variants) => {
  const variantsWithImages = variants.filter((variant) => (variant.featured_image && variant.featured_image.position))
  return variantsWithImages.map(variant => ({imagePosition: variant.featured_image.position, options: variant.options, id: variant.id}))
}

export default mapOptionsByImageIndex;